export default function FormTextarea({
    label,
    name,
    value = '',
    onChange,
    error,
    required = false,
    placeholder,
    disabled = false,
    helpText,
    rows = 3,
    maxLength,
    showCount = false,
    className = '',
    ...props
}) {
    const handleChange = (e) => {
        onChange(e.target.value);
    };

    const currentLength = (value ?? '').length;

    return (
        <div className={className}>
            {label && (
                <label className="form-label" htmlFor={name}>
                    {label}
                    {required && <span className="text-danger ms-1">*</span>}
                </label>
            )}
            <textarea
                id={name}
                name={name}
                className={`form-control ${error ? 'is-invalid' : ''}`}
                value={value ?? ''}
                onChange={handleChange}
                placeholder={placeholder}
                disabled={disabled}
                rows={rows}
                maxLength={maxLength}
                {...props}
            />
            {error && <div className="invalid-feedback">{error}</div>}
            <div className="d-flex justify-content-between">
                {helpText ? <div className="form-help-text">{helpText}</div> : <div />}
                {showCount && (
                    <div className="form-char-count">
                        {currentLength}{maxLength ? ` / ${maxLength}` : ''}
                    </div>
                )}
            </div>
        </div>
    );
}
